module.exports = __webpack_public_path__ + "static/media/Panorama-Transilvanian-sunset.bcd64132.jpg";